import Api from '../Api';

class CandidateSkillsApi extends Api {
  constructor() {
    super('candidates/preference-matching/skills', 'candidateskills');
  }
}
const candidateSkillsApi = new CandidateSkillsApi();
export default candidateSkillsApi;
